import { useEffect } from "react";
import { formatTitleSubscription } from "../../lib/payment/formatTitleSubscription";
import { PriceFromStripe } from "../../interfaces/apiRequests/PriceFromStripe";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import useUser from "../user/useUser";
import { useListingModalSwapOneTimeContext } from "../../components/training-plan/material/listingModal/listingModalSwapOneTime";

export const useSetSubscriptionFromPrice = () => {
  const prices = useSelector((state: RootState) => state.stripePrices.value);
  const { user } = useUser();
  const { dispatch } = useListingModalSwapOneTimeContext();

  useEffect(() => {
    if (prices != null) {
      const currentSubscriptionTitle = formatTitleSubscription(
        user.subscription_data.subscriptionPlan.title,
      );

      const subscriptionFromUser = prices[
        currentSubscriptionTitle
      ] as PriceFromStripe;

      dispatch({
        subscription:
          subscriptionFromUser.subscriptionPlanPaymentProviders.find(
            (value) => value.paymentProvider === "stripe",
          ),
      });
    }
  }, [prices, user.subscription_data]);
};
